import React, { useEffect } from 'react';
import './JsonModal.scss'; // Импорт собственного CSS
import JsonViewer from './JsonViewer';

const JsonModal = ({ isOpen, onClose, data, title = "JSON Details" }) => {
    console.log('JsonModal isOpen:', isOpen, 'data:', data);

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="json-modal-overlay" onClick={onClose}>
            <div className="json-modal-content" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="json-modal-header">
                    <h2 className="json-modal-title">
                        <i className="fas fa-code"></i>
                        {title}
                    </h2>
                    <button className="json-modal-close-btn" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                {/* Content */}
                <div className="json-modal-body">
                    <JsonViewer data={data} title={title} />
                </div>

                {/* Footer */}
                <div className="json-modal-footer">
                    <div className="json-modal-footer-info">
                        <i className="fas fa-info-circle"></i>
                        Click outside or press ESC to close
                    </div>
                    <button className="json-modal-footer-close-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default JsonModal;